type ErrorDisplayProps = {
  message: string;
};

const ErrorDisplay = ({ message }: ErrorDisplayProps) => {
  return (
    <div className="flex h-full min-h-40 flex-col items-center justify-center text-center">
      <section>
        <h1 className="mb-2">Sorry! Something unexpected happened</h1>
        <h2 className="italic text-neutral-500">{message}</h2>
      </section>
    </div>
  );
};

export default ErrorDisplay;
